import { http } from '@/http'
import { dataShared } from '../store'

const PATH = 'transmission/'
const C_PREFIX = 'client/'

class SharedService {
  // login
  static async me (data) {
    return http.get('auth/mecus', data)
  }

  static async login (data, redirect = null) {
    return http.post(`auth/login?redirect=${redirect}`, data)
  }

  static async signUp (data, redirect = null) {
    return http.post(`auth/register?redirect=${redirect}`, data)
  }

  // live
  static async getLiveById (id) {
    return http.get(PATH.concat('token/').concat(id))
  }

  static async checkToken (token) {
    return http.get('embed/' + token)
  }

  // notices
  static async getNotices () {
    return http.get(C_PREFIX.concat('notices'))
  }

  static async getCollect () {
    return http.get(C_PREFIX.concat('noticesCollect'))
  }

  // events
  static async getEvents () {
    return http.get(C_PREFIX.concat('events'))
  }

  static async nextEvents () {
    return http.get(C_PREFIX.concat('next-events'))
  }

  static async getEventById (eventId) {
    return http.get(C_PREFIX.concat('event-by/').concat(eventId))
  }

  static async eventsByCustomer (id) {
    return http.get(C_PREFIX.concat('events-by-customer/').concat(id))
  }

  static async checkAccess () {
    return http.get(C_PREFIX.concat('events'))
  }

  static async watchEventById (id) {
    const cId = dataShared.getters.getDataByUserLogged

    const headers = {
      headers: {
        __customer_id: cId?.id
      }
    }

    return http.get(C_PREFIX.concat('check-access-by/').concat(id).concat('/event'), headers)
  }

  static async getLives () {
    return http.get(C_PREFIX.concat('lives'))
  }

  // home
  static async getCarroussel () {
    return http.get('app/get-carroussel')
  }

  static async getMainDesc () {
    return http.get('app/get-main-desc')
  }

  static async getMainEvent () {
    return http.get('app/get-mainEvent')
  }

  static async getHighlights () {
    return http.get('app/get-highlights')
  }

  static async getBannerLogin () {
    return http.get('app/get-banner')
  }
  static async getLogo () {
    return http.get('app/get-logo')
  }
  static async getDescriptionsDownload () {
    return http.get('app/get-download-conf')
  }

  // profile
  static async getCustomerInfo (id) {
    return http.get(`app/customer-by/${id}`)
  }

  static async beAFighter (id) {
    return http.get(C_PREFIX.concat(`be-a-fighter/${id}`))
  }

  static async updateData (data) {
    const cId = dataShared.getters.getDataByUserLogged
    const d = { ...data, cId: cId?.id }

    return http.post(`update-data`, d)
  }

  // purchase
  static async setSponsorshipPage (fighter, secret) {
    return http.get(C_PREFIX.concat(`check/${fighter}/${secret}`))
  }

  static async validityCoupon (coupon) {
    return http.get(C_PREFIX.concat(`validity-coupon/${coupon}`))
  }

  static async initiate (id, couponId = null) { // payment
    const cId = dataShared.getters.getDataByUserLogged

    const data = {
      event_id: id,
      customer_id: cId?.id,
      __coupon_id: couponId
    }

    return http.post('payments/initiate', data)
  }
}

export default SharedService
